/**
 * お知らせカウント数
 */
 import Vue from 'vue'
 import * as httpConst from '../../../constants/httpConst'
 import * as types from '../../mutation-types/driver-types'
 import {DRIVER_NOTIFICATION_RESET_CONDITION} from "../../mutation-types/driver-types";
 
 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/notifications`
 
 const getDefaultState = () => {
   return {
    unread_count: 0, 
   }
 }
 
 const notification_alert = {
   namespaced: true,
   state: getDefaultState(),
   getters: {},
   actions: {
     fetchUnreadCount({ commit }) {
       const api_path = `${API_PATH}/unread_count`
       return new Promise((resolve, reject) => {
         Vue.$http.get(api_path).then(data => {
           let content = data.content
           commit(types.DRIVER_NOTIFICATION_COUNT, { count: content.unread_count })
           resolve(content)
         }).catch((error) => {
           reject()
         })
       })
     },
   },
   mutations: {
     [types.DRIVER_NOTIFICATION_COUNT] (state, { count }) {
       state.unread_count = count
     },
   },
 }
 
 export default notification_alert
 
 